import React from 'react';
import PropTypes from 'prop-types';
import { SFNavigationOptions } from '../utils/types';
import css from './MenuOptionsList.css';
import MenuOption from './MenuOption';

export default class MenuOptionsList extends React.Component {
  render() {
    return (
      <ul className={css['options-list']}>
        {this.props.options.map((option, i) => (
          <MenuOption
            key={i}
            updateSection={this.props.updateSection}
            currentSection={this.props.currentSection}
            {...option}
          />)
        )}
      </ul>
    );
  }
}

MenuOptionsList.propTypes = {
  options: SFNavigationOptions.isRequired,
  updateSection: PropTypes.func.isRequired,
  currentSection: PropTypes.string
};
